export const NOTIFICATION_TYPES = {
    PARTICIPANT_JOINED: "202",
    NETWORK_QUALITY: "901",
    CHAT_TEXT_MSG: "1001", // for chat text msg
    MICROPHONE_PERMISSION: "208",
    CAMERA_PERMISSION: "209",
    VIDEO_QUALITY: "701", // for video quality changes
    ZOOM_LEVEL: {
        AGENT_TO_GUEST: "497",
        GUEST_TO_AGENT: "496",
    },
    VIDEO_SCREENSHARE_STATUS: "510",
    TAKE_PHOTO: {
        TO_STREAMING_USER: "500",
        STREAMING_USER_TO_ALL: "501",
    },
    EXTRACT_TEXT: {
        AGENT_TO_ALL: "505", // all user for OCR is started by Agent
        GUEST_TO_AGENT: "506", // send message for uploading image
    },
    LOCATION: "207",
    UPLOAD_FILE: "801",
    OFFLINE_MODE_UPLOAD_FILE: "802",
    RECORDING: {
        START: "300",
        STOP: "301",
        START_ERROR: "302", // AgentCouldNotConnect
    },
    LIVEPOINTER: {
        STATUS_START_STOP: "602",
        POINT: "601",
    },
    BATTERY_LOW_MESSAGE: "667", // send message for low battery from guest to agent
    NETWORK_INFO: "666", // for sharing network information,
    FLASHLIGHT: {
        FROM_LOCAL: "498",
        FROM_REMOTE: "499",
    },
    MARKUP: {
        AGENT_TO_ALL: "503", // all user for markup is started by Agent
        GUEST_TO_AGENT: "504", // all user for markup is started by Agent
    },
    AR_MARKUP: {
        AGENT_TO_ALL: "2503", // all user for AR markup is started by Agent
        GUEST_TO_AGENT: "2504", // all user for AR markup is started by Agent
    },
    MARKUP_LIVESTREAM: {
        AGENT_TO_ALL: "1503", // all user for Live stream markup is started by Agent
        GUEST_TO_AGENT: "1504", // all user for Live stream markup is started by Agent
    },
    MULTI_STREAM: {
        EXPAND: "401",
        COLLAPSE: "402",
    },
    REMOTE_MARKUP: "337",
    REMOTE_AR_MARKUP_LIVESTREAM: "2337",
    REMOTE_MARKUP_LIVESTREAM: "1337",
    REMOTE_VIDEO: {
        SUBSCRIPTION_FAILED: "555",
    },
    KNOW_MOBILE_APP_AR_STATUS: "705",
    MEASUREMENT_START_STOP: "706",
    AR_MEASUREMENT: {
        POINT: "1601",
        AGENT_TO_ALL: "1603",
        GUEST_TO_AGENT: "1604",
    },
    HOST_TO_GUEST: {
        REMOVE_USER: "100",
        AUDIO_ON_OFF: "101",
        VIDEO_START_STOP: "102",
        SCREENSHARE_START_STOP: "103",
    },
    SCREENSHARE_STATUS: "104",
    VIDEO_STATUS: "105",
    REQUEST_PERMISSION_TO_AGENT_FOR_MIC_CAMERA_STRAT: "106",
    REQUESTED_MIC_PERMISSION_ACCEPTED_REJECTED_BY_AGENT: "107",
    REQUESTED_CAMERA_PERMISSION_ACCEPTED_REJECTED_BY_AGENT: "108",
    OFFLINE_MODE: {
        START: "109",
        RECONNECT_USER: "110",
        PRIVATE_MODE_NOT_SUPPORTED: "111", // for iOS private mode not supported
    },
};
